"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.formatGenerator = void 0;

var _round2 = _interopRequireDefault(require("lodash/round"));

var _findIndex2 = _interopRequireDefault(require("lodash/findIndex"));

var _find5 = _interopRequireDefault(require("lodash/find"));

var _assignWith2 = _interopRequireDefault(require("lodash/assignWith"));

var _react = require("react");

var _jsCookie = _interopRequireDefault(require("js-cookie"));

var _CurrencyContext = _interopRequireDefault(require("./CurrencyContext"));

var _CurrencyHelper = _interopRequireWildcard(require("./CurrencyHelper"));

var _CurrencyConvert = require("./CurrencyConvert");

var _constants = require("./constants");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// 默认货币代码 CNY
var defaultCurrency = 'CNY'; // 默认货币保存精度 10**2=1000

var defaultCurrencyDigit = 2; // 默认百分比保存精度 10**2=100

var defaultPresentDigit = 2; // 默认语言

var defaultLang = 'zh-hans-cn'; // 精度表

var digitsMap = new Map(); // 国家代码 格式化对象map 避免多次创建

var formatUtilMap = new Map(); // 单位表

var symbolsMap = new Map(); // 特殊处理精度的货币配置

var hardcoreConfigs = _constants.HARD_CODE_CONFIG;

var isLaxNull = function isLaxNull(value) {
  return value === '' || value === undefined || value === null;
}; // 额外处理需要hardcore 精度的货币


var hardcodeDigit = function hardcodeDigit(code) {
  var _hardcoreConfig$digit, _hardcoreConfig$digit2;

  var hardcoreConfig = hardcoreConfigs.find(function (config) {
    return config.code === code;
  });
  return {
    minimumFractionDigits: (_hardcoreConfig$digit = hardcoreConfig === null || hardcoreConfig === void 0 ? void 0 : hardcoreConfig.digit) !== null && _hardcoreConfig$digit !== void 0 ? _hardcoreConfig$digit : void 0,
    maximumFractionDigits: (_hardcoreConfig$digit2 = hardcoreConfig === null || hardcoreConfig === void 0 ? void 0 : hardcoreConfig.digit) !== null && _hardcoreConfig$digit2 !== void 0 ? _hardcoreConfig$digit2 : void 0
  };
};

var hardCodeCurrencyDisplay = function hardCodeCurrencyDisplay(code) {
  var _CURRENCY_DISPLAY_HAR;

  return (_CURRENCY_DISPLAY_HAR = _constants.CURRENCY_DISPLAY_HARDCODE[code]) !== null && _CURRENCY_DISPLAY_HAR !== void 0 ? _CURRENCY_DISPLAY_HAR : {};
};
/** hard code 的货币进行语言映射 */


var hardCodeSymbol = function hardCodeSymbol(code, lang) {
  var _SYMBOL_HARD_CODE_CON;

  if (!_constants.SYMBOL_HARD_CODE_CONFIG[code]) return lang;
  return (_SYMBOL_HARD_CODE_CON = _constants.SYMBOL_HARD_CODE_CONFIG[code][lang]) !== null && _SYMBOL_HARD_CODE_CON !== void 0 ? _SYMBOL_HARD_CODE_CON : lang;
}; // 格式化对象生成器


var formatGenerator = function formatGenerator(code, lang) {
  var realLang = hardCodeSymbol(code, lang);
  return new Intl.NumberFormat(realLang, _objectSpread(_objectSpread({
    style: 'currency',
    currency: code
  }, hardCodeCurrencyDisplay(code)), hardcodeDigit(code)));
}; // 缓存的key生成器


exports.formatGenerator = formatGenerator;

var cacheKeyGenerator = function cacheKeyGenerator(_ref) {
  var code = _ref.code,
      lang = _ref.lang;
  var countryCode = code === null || code === void 0 ? void 0 : code.toUpperCase();
  var language = lang === null || lang === void 0 ? void 0 : lang.toUpperCase();

  if (countryCode && language) {
    return "".concat(countryCode, "-").concat(language);
  }

  if (countryCode) {
    return countryCode;
  }

  if (language) {
    return language;
  }

  return '';
};
/**
 * 按照货币精度格式化金额
 * @param value
 * @param options
 * @returns string
 */


var format = function format(value, options) {
  var _cacheKeyGenerator;

  var decimalDigits = defaultCurrencyDigit;
  var code = (options === null || options === void 0 ? void 0 : options.code) || defaultCurrency;
  var lang = (options === null || options === void 0 ? void 0 : options.lang) || defaultLang;
  var digits = Math.pow(10, decimalDigits);
  var f = null;
  var cacheFormat = formatUtilMap.get((_cacheKeyGenerator = cacheKeyGenerator({
    code: code,
    lang: lang
  })) !== null && _cacheKeyGenerator !== void 0 ? _cacheKeyGenerator : '');

  if (cacheFormat) {
    f = cacheFormat;
  } else {
    f = formatGenerator(code, lang); // 将format方法保存到map 下次直接取

    formatUtilMap.set(cacheKeyGenerator({
      code: code,
      lang: lang
    }), f); // 顺便将对应精度保存

    digitsMap.set(code, f.resolvedOptions().maximumFractionDigits);
  } // value 默认统一除1000


  return f.format(value / digits);
};

/**
 * 此方法不再推荐使用, 即将弃用, 请谨慎使用!!!!
 * @deprecated
 * @param value
 * @param platformName
 */
var formatByPlatform = function formatByPlatform(value, platformName) {
  console.warn('formatByPlatform 此货币格式化方法不再支持，请及时修改！！！！');
  var supportPlatforms = ['STOREFRONT', 'ADMIN', 'DASH'];
  var hitPlatform = supportPlatforms.indexOf(platformName) === -1;
  var baseFormatOptions = {};

  if (window === undefined) {
    return null;
  }

  if (hitPlatform) {
    console.warn('请传入第二个参数platformName，目前仅支持STOREFRONT、ADMIN、DASH');
    return null;
  }

  if (platformName === 'STOREFRONT') {
    baseFormatOptions = {
      code: _jsCookie["default"].get('currency_code'),
      lang: _jsCookie["default"].get('lang') // 目前商家前台还没有该字段.. todo...

    };
  } else if (platformName === 'ADMIN') {
    baseFormatOptions = {
      code: _jsCookie["default"].get('a_currency_code'),
      lang: _jsCookie["default"].get('a_lang')
    };
  } else if (platformName === 'DASH') {
    baseFormatOptions = {
      code: _jsCookie["default"].get('d_currency_code'),
      // 目前dash还没有该字段（预留）
      lang: _jsCookie["default"].get('d_lang') // 目前dash还没有该字段（预留

    };
  }

  return format(value, baseFormatOptions);
};
/**
 * 通过国家code获取该国家货币的精度
 * @param code
 */


var getDigitsByCode = function getDigitsByCode(code) {
  if (typeof digitsMap.get(cacheKeyGenerator({
    code: code
  })) === 'number') {
    return digitsMap.get(cacheKeyGenerator({
      code: code
    }));
  } // 精度与语言无关 所以写死


  var digit = formatGenerator(code, 'zh-cn').resolvedOptions().maximumFractionDigits;
  digitsMap.set(cacheKeyGenerator({
    code: code
  }), digit);
  return digit;
};
/**
 * 通过国家code获取该国家货币的单位
 * @param code
 * @param lang
 * @param options
 *        options.lang 语言
 *        options.mappingSymbolInConst 是否使用 hardcode 表来映射 code
 *        如果 options 是字符串形式，则表示设置为 lang 参数
 */


var getSymbolByCode = function getSymbolByCode(code, options) {
  options = typeof options === 'string' ? {
    lang: options
  } : options; // 合并选项的策略

  var assignStrategies = function assignStrategies(objValue, srcValue) {
    return isLaxNull(srcValue) ? objValue : srcValue;
  }; // 合并后的选项


  var finalizeOptions = (0, _assignWith2["default"])({
    lang: 'zh-cn',
    mappingSymbolInConst: false
  }, options, assignStrategies);
  var _ref2 = finalizeOptions,
      lang = _ref2.lang,
      mappingSymbolInConst = _ref2.mappingSymbolInConst;
  var symbol = '';

  if (mappingSymbolInConst) {
    symbol = _constants.CODE_TO_SYMBOL[code];

    if (!isLaxNull(symbol)) {
      return symbol;
    }
  }

  if (symbolsMap.get(cacheKeyGenerator({
    code: code,
    lang: lang
  }))) {
    return symbolsMap.get(cacheKeyGenerator({
      code: code,
      lang: lang
    }));
  }

  var format = formatGenerator(code, lang);

  if (format.formatToParts) {
    var _find$value, _find;

    symbol = (_find$value = (_find = (0, _find5["default"])(format.formatToParts(), ['type', 'currency'])) === null || _find === void 0 ? void 0 : _find.value) !== null && _find$value !== void 0 ? _find$value : '';
  } else {
    var _intl$format$replace;

    var realLang = hardCodeSymbol(code, lang); // ie 兼容方式 hack

    var intl = new Intl.NumberFormat(realLang, _objectSpread(_objectSpread({
      style: 'currency',
      currency: code
    }, hardCodeCurrencyDisplay(code)), {}, {
      // 将小数点都去掉方便replace
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }));
    symbol = (_intl$format$replace = intl.format(0).replace('0', '')) === null || _intl$format$replace === void 0 ? void 0 : _intl$format$replace.trim();
  }

  symbolsMap.set(cacheKeyGenerator({
    code: code,
    lang: lang
  }), symbol);
  return symbol;
};
/**
 * 通过国家code获取该国家货币的单位所在位置, 在前还是在后
 * @param code
 */


var getSymbolOrderByCode = function getSymbolOrderByCode(code) {
  var lang = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'zh-cn';
  var order = 0;
  var format = formatGenerator(code, lang);

  if (format.formatToParts) {
    order = (0, _findIndex2["default"])(format.formatToParts(), ['type', 'currency']);
  } // ie 没有此方法, 则直接返回0 所以ie环境下此方法都返回prefix


  return order > 0 ? 'suffix' : 'prefix';
};
/**
 * 按照保存精度反格式化值
 * eg: 10.55 -> 1055
 * @param value
 * @param decimalDigits = 2
 * @returns number
 */


var unformatNumber = function unformatNumber(value) {
  var decimalDigits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultCurrencyDigit;
  var v = (0, _round2["default"])((typeof value !== 'number' ? Number(value) : value) * Math.pow(10, decimalDigits), 0);
  return v;
};
/**
 * 按照货币保存精度反格式化金额
 * eg: 10.55 -> 1055
 * @param value
 * @returns number
 */


var unformatCurrency = function unformatCurrency(value) {
  return unformatNumber(value, defaultCurrencyDigit);
};
/**
 * 按照百分比保存精度反格式化金额
 * eg: 10.55 -> 1055
 * @param value
 * @returns number
 */


var unformatPercent = function unformatPercent(value) {
  return unformatNumber(value, defaultPresentDigit);
};
/**
 * 按照保存精度返回整形数据
 * eg: 1055 -> 10.55
 * @param value
 * @param decimalDigits = 2
 * @returns number
 */


var formatNumber = function formatNumber(value) {
  var decimalDigits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultCurrencyDigit;
  var v = typeof value !== 'number' ? Number(value) : value;
  return v / Math.pow(10, decimalDigits);
};
/**
 * 按照货币保存精度返回正确的货币值
 * eg: 1055 -> 10.55
 * @param value
 * @returns number
 */


var formatCurrency = function formatCurrency(value) {
  return formatNumber(value, defaultCurrencyDigit);
};
/**
 * 按照百分比保存精度返回正确百分比值
 * 10.51 -> 1051
 * @param value
 * @returns number
 */


var formatPercent = function formatPercent(value) {
  return formatNumber(value, defaultPresentDigit);
};
/**
 * 通过国家code和语言获取小数点的符号
 * @param code
 */


var getDecimalSymbolByCode = function getDecimalSymbolByCode(code, lang) {
  var decimal = '';
  var format = formatGenerator(code, lang);

  if (format.formatToParts) {
    var _find$value2, _find3;

    decimal = (_find$value2 = (_find3 = (0, _find5["default"])(format.formatToParts(1.0), ['type', 'decimal'])) === null || _find3 === void 0 ? void 0 : _find3.value) !== null && _find$value2 !== void 0 ? _find$value2 : '';
  } else {
    // ie 没有此方法,hack方式
    var realLang = hardCodeSymbol(code, lang);
    var intl = new Intl.NumberFormat(realLang, _objectSpread(_objectSpread({
      currency: code
    }, hardCodeCurrencyDisplay(code)), {}, {
      // 将小数点都去掉方便replace
      useGrouping: false
    })); // 使用正则将数字去掉留下小数点

    decimal = intl.format(0.1).replace(/[0-9]*/g, '');
  }

  return decimal;
};
/**
 * 通过国家code和语言获取分隔符的符号
 * @param code
 */


var getGroupSymbolByCode = function getGroupSymbolByCode(code, lang) {
  var group = '';
  var format = formatGenerator(code, lang);

  if (format.formatToParts) {
    var _find$value3, _find4;

    group = (_find$value3 = (_find4 = (0, _find5["default"])(format.formatToParts(10000.0), ['type', 'group'])) === null || _find4 === void 0 ? void 0 : _find4.value) !== null && _find$value3 !== void 0 ? _find$value3 : '';
  } else {
    var realLang = hardCodeSymbol(code, lang); // ie 没有此方法,hack方式

    var decimal = getDecimalSymbolByCode(code, realLang);
    group = decimal === '.' ? ',' : '.';
  }

  return group;
};
/**
 * 获取格式化结果的每个parts
 * eg: [
  { type: "integer",  value: "3"   },
  { type: "group",    value: "."   },
  { type: "integer",  value: "500" },
  { type: "decimal",  value: ","   },
  { type: "fraction", value: "00"  },
  { type: "literal",  value: " "   },
  { type: "currency", value: "€"   }
]
 */


var getFormatParts = function getFormatParts(value, options) {
  var _options$code = options.code,
      code = _options$code === void 0 ? '' : _options$code,
      _options$lang = options.lang,
      lang = _options$lang === void 0 ? '' : _options$lang,
      mappingSymbolInConst = options.mappingSymbolInConst;
  var format = formatGenerator(code, lang);

  if (format.formatToParts) {
    return format.formatToParts(value);
  } else {
    var _fraction$trim;

    // ie 没有此方法,hack方式
    var formatStr = format.format(value);
    var group = getGroupSymbolByCode(code, lang);
    var decimal = getDecimalSymbolByCode(code, lang);
    var symbolOrder = getSymbolOrderByCode(code, lang);
    var symbol = getSymbolByCode(code, {
      lang: lang,
      mappingSymbolInConst: mappingSymbolInConst
    });
    var rst = [];

    var _formatStr$replace$sp = formatStr.replace(symbol !== null && symbol !== void 0 ? symbol : '', '').split(decimal),
        _formatStr$replace$sp2 = _slicedToArray(_formatStr$replace$sp, 2),
        integerValue = _formatStr$replace$sp2[0],
        fraction = _formatStr$replace$sp2[1];

    if (!integerValue) return rst;
    integerValue.split(group).forEach(function (item, index) {
      rst.push({
        type: 'integer',
        value: item
      });
      if (index !== integerValue.length - 1) rst.push({
        type: 'group',
        value: group
      });
    });
    rst.push({
      type: 'decimal',
      value: decimal
    });
    rst.push({
      type: 'fraction',
      value: (_fraction$trim = fraction === null || fraction === void 0 ? void 0 : fraction.trim()) !== null && _fraction$trim !== void 0 ? _fraction$trim : ''
    });

    if (symbolOrder === 'prefix') {
      rst.unshift({
        type: 'currency',
        value: symbol !== null && symbol !== void 0 ? symbol : ''
      });
    } else {
      rst.push({
        type: 'currency',
        value: symbol !== null && symbol !== void 0 ? symbol : ''
      });
    }

    return rst;
  }
};
/**
 * 货币工具hook (不包含汇率换算)
 * @param code
 */


var useCurrency = function useCurrency(code) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var context = (0, _react.useContext)(_CurrencyContext["default"]);
  var envLang = context.lang,
      envCurrencyCode = context.currencyCode,
      fromCurrencyCode = context.fromCurrencyCode;
  var lang = envLang || defaultLang;
  var mappingSymbolInConst = options.mappingSymbolInConst;
  var country = (0, _react.useMemo)(function () {
    return code || envCurrencyCode || fromCurrencyCode || defaultCurrency;
  }, [code, envCurrencyCode, fromCurrencyCode]); // 初始化格式化函数

  var formatUtil = (0, _react.useMemo)(function () {
    return function (value) {
      return format(value, {
        lang: envLang,
        code: country
      });
    };
  }, [envLang, country]); // 精度

  var digit = (0, _react.useMemo)(function () {
    return getDigitsByCode(country !== null && country !== void 0 ? country : defaultCurrency);
  }, [country]); // 单位

  var symbol = (0, _react.useMemo)(function () {
    return getSymbolByCode(country !== null && country !== void 0 ? country : defaultCurrency, {
      lang: lang,
      mappingSymbolInConst: mappingSymbolInConst
    });
  }, [country, lang, mappingSymbolInConst]); // 小数点标识

  var decimalSymbol = (0, _react.useMemo)(function () {
    return getDecimalSymbolByCode(country !== null && country !== void 0 ? country : defaultCurrency, lang);
  }, [country, lang]);
  return {
    formatUtil: formatUtil,
    country: country,
    digit: digit,
    symbol: symbol,
    decimalSymbol: decimalSymbol
  };
};

var _default = {
  format: format,

  /**
   * @deprecated
   * 弃用
   */
  formatByPlatform: formatByPlatform,
  unformatNumber: unformatNumber,
  formatNumber: formatNumber,
  unformatCurrency: unformatCurrency,
  unformatPercent: unformatPercent,
  formatCurrency: formatCurrency,
  formatPercent: formatPercent,
  getDigitsByCode: getDigitsByCode,
  getSymbolByCode: getSymbolByCode,
  getSymbolOrderByCode: getSymbolOrderByCode,
  useCurrency: useCurrency,
  CurrencyHelper: _CurrencyHelper["default"],
  // 汇率相关方法
  convertFormat: _CurrencyConvert.convertFormat,
  useConvertFormat: _CurrencyConvert.useConvertFormat,
  getCurrencyRate: _CurrencyConvert.getCurrencyRate,
  covertCalc: _CurrencyConvert.covertCalc,

  /**
   * ssr 数据预加载方法
   */
  preload: _CurrencyHelper.preload,
  getDecimalSymbolByCode: getDecimalSymbolByCode,
  getGroupSymbolByCode: getGroupSymbolByCode,
  getFormatParts: getFormatParts
};
exports["default"] = _default;